export default class NumberUtility {
  /**
   * ゼロ埋め
   */
  static zeroFill(value: number, zeros: number): string {
    let newValue = `${value}`;
    while (newValue.length < zeros) {
      newValue = `0${newValue}`;
    }
    return newValue;
  }
}
